export const APIURL = 'https://api-apps.shedpaper.com';
